import { ReactNode, createContext } from "react";
import useContaPagar, { ContaPagarType, CreateContaPagarType, UpdateContaPagarType, EfetuarBaixaPagarRequest } from "./hooks/useContaPagar";

interface ContaPagarContextProviderProps {
    children: ReactNode;
}

export interface ContaPagarContextData {
    getAllContaPagarPaged: (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
        dataFinal?: string,
        status?: number,
        codigoTransacao?: number | string,
        documento?: string,
        historico?: string,
        contaFinanceiraId?: number,
        categoriaFinanceiraId?: number,
        formaPagamentoId?: number,
        tipoContaPagarId?: number,
        terceiroId?: number,
        alunoId?: number
    ) => Promise<ContaPagarType[] | null>;
    setContaPagar: any;
    contaPagar: ContaPagarType;
    setListContaPagar: any;
    listContaPagar: ContaPagarType[];
    setInitialListContaPagar: any;
    initialListContaPagar: ContaPagarType[];
    setContaPagarPageCount: any;
    contaPagarPageCount: number;
    createContaPagar: (createContaPagarType: CreateContaPagarType) => Promise<ContaPagarType | null>;
    createContaPagar_semNotificacao: (createContaPagarType: CreateContaPagarType) => Promise<ContaPagarType | null>;
    updateContaPagar: (updateContaPagarType: UpdateContaPagarType) => Promise<UpdateContaPagarType | null>;
    deleteContaPagar: (id: number) => Promise<ContaPagarType | null>;
    handleGetContaPagarByEmpresaId: (empresaId: number) => Promise<ContaPagarType[] | null>;
    listContaPagarByEmpresa: ContaPagarType[];
    setListContaPagarByEmpresa: any;
    efetuarBaixaContaPagar: (request: EfetuarBaixaPagarRequest) => Promise<boolean>;
    reverterContaParaPendente: (contaPagarId: number) => Promise<boolean>;
    getContaPagarAttachment: (contaPagarId: number) => void;
    contaPagarTotalValor: number;
    setContaPagarTotalValor: (valor: number) => void;
    exportRelatorioContaPagar: (
        filters: any,
        selectedFields: string[]
    ) => Promise<void>;

}

const initialState: ContaPagarContextData = {
    getAllContaPagarPaged: async (
        pageNumber: number,
        pageSize: number,
        empresaId?: number,
        dataInicial?: string,
        dataFinal?: string,
        status?: number,
        codigoTransacao?: number | string,
        documento?: string,
        historico?: string,
        contaFinanceiraId?: number,
        categoriaFinanceiraId?: number,
        formaPagamentoId?: number,
        tipoContaPagarId?: number,
        terceiroId?: number,
        alunoId?: number
    ) => {
        return Promise.resolve(null);
    },
    setContaPagar: () => { },
    contaPagar: {
        id: 0,
        valor: 0,
        taxa: 0,
        vencimento: "",
        dataEmissao: "",
        dataBaixa: "",
        documento: "",
        codigoTransacao: 0,
        historico: "",
        bandeira: "",
        status: 0,
        contaFinanceiraId: 0,
        contaFinanceiraName: "",
        categoriaFinanceiraId: 0,
        categoriaFinanceiraName: "",
        formaPagamentoId: 0,
        formaPagamentoName: "",
        contaProvisionadaId: 0,
        custoId: 0,
        isProvisionada: false,
        hasReceiptAttachment: false,
        tipoContaPagarId: 0,
        tipoContaPagarName: "",
    },
    setListContaPagar: () => { },
    listContaPagar: [],
    setInitialListContaPagar: () => { },
    initialListContaPagar: [],
    setContaPagarPageCount: () => { },
    contaPagarPageCount: 0,
    createContaPagar: async (createContaPagarType: CreateContaPagarType) => {
        return Promise.resolve(null);
    },
    createContaPagar_semNotificacao: async (createContaPagarType: CreateContaPagarType) => {
        return Promise.resolve(null);
    },
    updateContaPagar: async (updateContaPagarType: UpdateContaPagarType) => {
        return Promise.resolve(null);
    },
    deleteContaPagar: async (id: number) => {
        return Promise.resolve(null);
    },
    handleGetContaPagarByEmpresaId: async (empresaId: number) => {
        return Promise.resolve(null);
    },
    listContaPagarByEmpresa: [],
    setListContaPagarByEmpresa: () => { },
    efetuarBaixaContaPagar: async () => false,
    reverterContaParaPendente: async () => false,
    getContaPagarAttachment: () => { },
    contaPagarTotalValor: 0,
    setContaPagarTotalValor: () => { },
    exportRelatorioContaPagar: async () => Promise.resolve(),
};

export const ContaPagarContext =
    createContext<ContaPagarContextData>(initialState);

export default function ContaPagarContextProvider({
    children,
}: ContaPagarContextProviderProps) {
    const {
        getAllContaPagarPaged,
        createContaPagar,
        createContaPagar_semNotificacao,
        updateContaPagar,
        deleteContaPagar,
        contaPagar,
        setContaPagar,
        setListContaPagar,
        listContaPagar,
        initialListContaPagar,
        setInitialListContaPagar,
        setContaPagarPageCount,
        contaPagarPageCount,
        handleGetContaPagarByEmpresaId,
        listContaPagarByEmpresa,
        setListContaPagarByEmpresa,
        efetuarBaixaContaPagar,
        reverterContaParaPendente,
        getContaPagarAttachment,
        setContaPagarTotalValor,
        contaPagarTotalValor,
        exportRelatorioContaPagar,
    } = useContaPagar();

    return (
        <ContaPagarContext.Provider
            value={{
                getAllContaPagarPaged,
                createContaPagar,
                createContaPagar_semNotificacao,
                updateContaPagar,
                deleteContaPagar,
                contaPagar,
                setContaPagar,
                setListContaPagar,
                listContaPagar,
                initialListContaPagar,
                setInitialListContaPagar,
                setContaPagarPageCount,
                contaPagarPageCount,
                handleGetContaPagarByEmpresaId,
                listContaPagarByEmpresa,
                setListContaPagarByEmpresa,
                efetuarBaixaContaPagar,
                reverterContaParaPendente,
                getContaPagarAttachment,
                setContaPagarTotalValor,
                contaPagarTotalValor,
                exportRelatorioContaPagar,
            }}
        >
            {children}
        </ContaPagarContext.Provider>
    );
}
